import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, List, Avatar, Empty } from "antd";
import { formatBytes, getFileImage, getFullDateHours } from "utils/helpers";
import { ReactComponent as DownloadFile } from 'assets/icons/download_blue.svg';
import { downloadUploadedFile, openUploadedFile } from 'store/forms/actions';
import { isBeneficiary, isCoe, isKtP, isMinistry, isSuperUser, isViewformDisabled } from 'utils';
import { useLocation } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { DownloadUpdateFile, StatusTag } from 'components';

const Documents = () => {
  const dispatch = useDispatch();
  const ApplicationFilesList = useSelector(state => state.appTrack?.apptrackDetails?.contentItems);
  const ApplicationFilesListMainforms = useSelector(state => state.forms?.documents?.contentItems);
  const apptrackDetails = useSelector(state => state.appTrack?.apptrackDetails);
  const parseFlag = apptrackDetails?.variablesIndexed?.parseFlag;
  const groups = useSelector(state => state.user?.groups);
  const location = useLocation();
  const appTrack = location.pathname.includes('apptrack');
  const voucherContract = useSelector(state => state.appTrack?.apptrackDetails?.variablesIndexed?.voucher?.contractId);
  const activeTaskName = apptrackDetails?.activeTaskName;
  const businessKey = apptrackDetails?.businessKey;
  const user = useSelector(state => state.user);

  console.log("apptrackDetails:", apptrackDetails);
  console.log("isViewformDisabled:", isViewformDisabled(window.location.pathname));

  // const contentItems = [
  //     {
  //         "title": "Υπογεγραμμένη Σύμβαση",
  //         "items": [
  //             {
  //                 "id": "bc26f82f-7c3a-4b61-8884-4580a7e67bcc",
  //                 "name": "2.pdf123123123 6545621542 5265541224.pdf",
  //                 "contentAvailable": true,
  //                 "contentStoreId": "12064",
  //                 "contentStoreName": "INTERNAL_FILE",
  //                 "mimeType": "application/pdf",
  //                 "simpleType": "pdf",
  //                 "field": "contractProvider",
  //                 "created": "2025-02-25T11:26:50.532+00:00",
  //                 "createdBy": "cosmote",
  //                 "size": 469513
  //             },
  //             {
  //                 "id": "f04f77c4-9517-44a0-b08e-156b289dee7d",
  //                 "name": "example1.pdf",
  //                 "contentAvailable": true,
  //                 "contentStoreId": "12673",
  //                 "contentStoreName": "INTERNAL_FILE",
  //                 "mimeType": "application/pdf",
  //                 "simpleType": "pdf",
  //                 "field": "contractProvider",
  //                 "created": "2025-03-04T11:39:18.269+00:00",
  //                 "createdBy": "provider_cosmote",
  //                 "size": 577896
  //             },
  //             {
  //                 "id": "f81cf6a4-431e-4e91-8791-a2841e9ed668",
  //                 "name": "example2.pdf",
  //                 "contentAvailable": true,
  //                 "contentStoreId": "12674",
  //                 "contentStoreName": "INTERNAL_FILE",
  //                 "mimeType": "application/pdf",
  //                 "simpleType": "pdf",
  //                 "field": "contractProvider",
  //                 "created": "2025-03-04T11:39:18.448+00:00",
  //                 "createdBy": "provider_cosmote",
  //                 "size": 577896
  //             },
  //             {
  //                 "id": "7cda2d5c-c988-48b7-94da-8e2ab09b12c0",
  //                 "name": "example3.pdf",
  //                 "contentAvailable": true,
  //                 "contentStoreId": "12675",
  //                 "contentStoreName": "INTERNAL_FILE",
  //                 "mimeType": "application/pdf",
  //                 "simpleType": "pdf",
  //                 "field": "contractProvider",
  //                 "created": "2025-03-04T11:39:18.612+00:00",
  //                 "createdBy": "provider_cosmote",
  //                 "size": 577896
  //             }
  //         ]
  //     }
  // ];


  const desiredOrder = [
    'Συμπληρωμένο σε Ηλεκτρονική Μορφή Excel "Δαπάνες Επένδυσης"',
    'Υπεύθυνη Δήλωση Σώρευσης',
    'Φορολογικό Έντυπο Ε3',
    'Υπεύθυνη Δήλωση Στοιχείων Πραγματικών Δικαιούχων',
    'Eκτύπωση από το Κεντρικό Μητρώο Πραγματικών Δικαιούχων',
    'Πιστοποιητικό Μεταβολών ΓΕΜΗ',
    'Άλλα Δικαιολογητικά'
  ];

  // Sort without mutating original list from Redux (safe copy)
  const sortedApplicationFilesList = [...(ApplicationFilesList || [])].sort((a, b) => {
    const indexA = desiredOrder.indexOf(a.title);
    const indexB = desiredOrder.indexOf(b.title);

    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });

  return (
    // isEmpty(!isBeneficiary(groups) ? appTrack ? ApplicationFilesList : ApplicationFilesListMainforms : ApplicationFilesList) ?
    false ?
      <div style={{ position: "absolute", top: "10%", left: "50%", minHeight: "500px" }}>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<>No data</>} />
      </div>
      :
      <>
        <p className="mt-6 mr-0 color-blue-3 text-bold font-size-24">
          Δικαιολογητικά
        </p>

        <div className='documentsWrapper'>
          <div className='documentsContent'>

            {parseFlag == false && (
              <>
                {(isCoe(user.groups) || isSuperUser(user.groups)) && (
                  <div className="updateFileComponentWrapper mb-3">
                    <DownloadUpdateFile type="business" file={sortedApplicationFilesList.filter(file => file?.items[0]?.field == 'businessPlanFile')} />
                    <DownloadUpdateFile type="eligibility" file={sortedApplicationFilesList.filter(file => file?.items[0]?.field == 'eligibilityFile')} />
                    <DownloadUpdateFile type="financial" file={sortedApplicationFilesList.filter(file => file?.items[0]?.field == 'financialModelFile')} />
                  </div>
                )}

                {(isBeneficiary(user.groups) || isMinistry(user?.groups)) && (
                  <div className="updateFileComponentWrapperLarge mb-3">
                    <DownloadUpdateFile large type="business" file={sortedApplicationFilesList.filter(file => file?.items[0]?.field == 'businessPlanFile')} />
                    <DownloadUpdateFile large type="eligibility" file={sortedApplicationFilesList.filter(file => file?.items[0]?.field == 'eligibilityFile')} />
                  </div>
                )}
              </>
            )
            }
            <Row gutter={24}>
              <Col span={24}>
                <List
                  className="applicationFilesList no-border"
                  itemLayout="vertical"
                  // dataSource={ApplicationFilesList}
                  // dataSource={!isBeneficiary(groups) ? 
                  //   appTrack ?
                  //   ApplicationFilesList
                  //   : ApplicationFilesListMainforms
                  // : ApplicationFilesList}
                  dataSource={sortedApplicationFilesList.filter(file => file?.items[0].field !== 'businessPlanFile' && file?.items[0].field !== 'eligibilityFile' && file?.items[0].field !== 'financialModelFile')}
                  renderItem={(item, index) => (
                    <div>
                      <div className="application-file-header">{item?.title + `${item?.title.includes('Σύμβαση') ? `: ${voucherContract}` : ''}`}</div>
                      <List.Item
                        extra={
                          item.items.map((info, index) => (
                            <div className="file-uris">
                              <div className="open-file-wrapper file-actions">
                                <a className="application-open-file-text"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    dispatch(openUploadedFile(info))
                                  }}
                                  target={"_blank"}>Άνοιγμα</a>
                              </div>
                              <div className="file-actions">
                                <a className="application-download-file-text"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    dispatch(downloadUploadedFile(info))
                                  }}
                                  download={info.name}>
                                  <DownloadFile /> Download</a>
                              </div>
                            </div>
                          ))
                        }
                      >
                        {item.items.map((info, index) => (
                          <List.Item.Meta className={index == 0 ? "first" : ""}
                            avatar={<Avatar src={getFileImage(info.simpleType)} />}
                            title={
                              <div style={{ display: "flex" }}>
                                <span className="application-file-name">{info.name}</span>
                              </div>
                            }
                            description={<div style={{ display: "flex" }}><span className="application-file-size">{formatBytes(info.size)}</span><span className='application-file-size'>, Updated: {getFullDateHours(info.created)}</span></div>}
                          />
                        ))}

                      </List.Item>
                    </div>
                  )}
                />
              </Col>
            </Row>
          </div>
        </div>
      </>
  );
};

export default Documents;
